import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../../common/SearchBar";
import { useAuth } from "../../../context/AuthContext";

const HeroSection = () => {
  const navigate = useNavigate();
  const { endUser, saveSearchReport } = useAuth();
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (query) => {
    if (query && query.trim()) {
      const trimmed = query.trim();
      setSearchQuery(trimmed);

      if (endUser && saveSearchReport) {
        saveSearchReport(trimmed, { title: trimmed });
      }

      navigate(`/reports?search=${encodeURIComponent(trimmed)}`, {
        state: { initialSearch: trimmed },
      });
    }
  };
  return (
    <section className="hero-section text-center d-flex align-items-center justify-content-center">
      <div className="container">
        <div className="animate-fade-up">
          <h1 className="display-4 fw-bold mb-4 hero-title">
            Intelligence That Helps You Make Better Business Decisions
          </h1>
        </div>
        <p className="lead mb-5 hero-subtitle animate-fade-up delay-1">
          Access syndicated market reports and custom research that help
          organizations understand markets, evaluate opportunities, monitor
          competitors, and make informed strategic decisions across global
          industries
        </p>

        <div
          className="mx-auto mb-5 animate-fade-up delay-2 position-relative"
          style={{ maxWidth: "700px", zIndex: 1050 }}
        >
          <SearchBar
            className="hero-search-bar"
            value={searchQuery}
            onSearch={handleSearch}
            placeholder="Search market reports, industries, or keywords..."
            debounce={300}
            showButton={true}
            buttonText="Search"
            enableSuggestions={true}
          />
        </div>

        {/* <div className="hero-actions d-flex flex-column flex-sm-row justify-content-center align-items-center gap-3 animate-fade-up delay-3">
          <Link
            to="/reports"
            className="btn px-4 py-2 rounded-pill explore-btn d-flex align-items-center justify-content-center gap-2 shadow"
          >
            Explore Our Platform <FaArrowRight />
          </Link>
          <Link
            to="/request-custom-research"
            className="btn px-4 py-2 rounded-pill custom-btn shadow-sm d-flex align-items-center justify-content-center"
          >
            Request Custom Research
          </Link>
        </div> */}
        <div className="mt-4 w-100 d-flex flex-wrap align-items-center justify-content-center gap-2 pb-2">
          <span className="populartext text-secondary small fw-medium flex-shrink-0">
            Popular Searches:
          </span>
          {[
            "Artificial Intelligence",
            "Electric Vehicles",
            "Sustainable Packaging",
            "Green Hydrogen",
            "Medical Devices",
            "Semiconductor Materials",
            "Carbon Capture",
            "Specialty Chemicals",
            "Marine Automation",
            "Consumer & Lifestyle Services",
            "Data Center",
          ].map((tag) => (
            <button
              key={tag}
              className={`btn popular-search-pill text-nowrap flex-shrink-0 ${searchQuery === tag ? "active" : ""}`}
              onClick={() => handleSearch(tag)}
              aria-label={`Search for ${tag}`}
            >
              {tag}
            </button>
          ))}
        </div>
      </div>
      <div className="hero-bg-overlay"></div>
    </section>
  );
};

export default HeroSection;
